<template>
    <svg t="1568938664125" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="699" style="width: 1em; height: 1em; opacity: 1;">
        <path d="M320 704h-32c-17.6 0-32-14.4-32-32s14.4-32 32-32h32c17.6 0 32 14.4 32 32s-14.4 32-32 32zM320 512h-32c-17.6 0-32-14.4-32-32s14.4-32 32-32h32c17.6 0 32 14.4 32 32s-14.4 32-32 32zM736 704H448c-17.6 0-32-14.4-32-32s14.4-32 32-32h288c17.6 0 32 14.4 32 32s-14.4 32-32 32zM736 512H448c-17.6 0-32-14.4-32-32s14.4-32 32-32h288c17.6 0 32 14.4 32 32s-14.4 32-32 32z" p-id="700"></path>
        <path d="M864 896H160c-52.8 0-96-43.2-96-96V288c0-52.8 43.2-96 96-96h128c17.6 0 32 14.4 32 32s-14.4 32-32 32h-128c-17.6 0-32 14.4-32 32v512c0 17.6 14.4 32 32 32h704c17.6 0 32-14.4 32-32V288c0-17.6-14.4-32-32-32h-128c-17.6 0-32-14.4-32-32s14.4-32 32-32h128c52.8 0 96 43.2 96 96v512c0 52.8-43.2 96-96 96z" p-id="701"></path>
        <path d="M528 352h-32c-52.8 0-96-43.2-96-96V128c0-52.8 43.2-96 96-96h32c52.8 0 96 43.2 96 96v128c0 52.8-43.2 96-96 96zM496 96c-17.6 0-32 14.4-32 32v128c0 17.6 14.4 32 32 32h32c17.6 0 32-14.4 32-32V128c0-17.6-14.4-32-32-32h-32z" p-id="702"></path>
    </svg>
</template>

<script>
export default {
  name: 'jobtitle',
  components: {
  },
  created() {
  }
}
</script>
